module.exports = __webpack_public_path__ + "components/rewards/hike-and-ride/static/logo-16d6e6209883224dbfe20854ff783b2b.webp";